import React from 'react';
import {
  SnbMenuHeaderUser,
} from '@components/common/snb/elements';

const SnbMenuHeader = () => {
  const { userInfo } = $hooks.useUser();

  return (
    <>
      <div className="tit-box">
        <h3 className="nav-tit">
          <strong>
            <SnbMenuHeaderUser />
            {userInfo.username}({userInfo.empno ? userInfo.empno : userInfo.userId})님,
          </strong>
          오늘도 활기찬 하루 보내세요!
        </h3>
      </div>  </>

  );
};

export default SnbMenuHeader;
